import { useState, useEffect } from 'react';
import { Fetch } from '../helpers/fetchWrapper';
import { useCancellablePromise } from '../helpers/promiseHandler';

const STATUS = {
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
};

const chatService = {
  _url: process.env.REACT_APP_CHAT_API_URL,

  async createChat(payload) {
    return await Fetch.post(`${this._url}`, payload, false, true);
  },
};

export default chatService;
